import { Component, OnInit, SimpleChanges, OnChanges, Output, EventEmitter, ViewContainerRef, ViewChild, ElementRef, AfterViewInit, Renderer2, ChangeDetectorRef, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { MaskEditField } from 'src/app/interfaces/user-authentication';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';


@Component({
    selector: 'app-form-view-number',
    templateUrl: './form-view-number.component.html',
    styleUrls: ['./form-view-number.component.css'],
    standalone: false
})
export class FormViewNumberComponent implements OnInit,OnChanges {

  canConfig:boolean = false;
  @Input() config:columnsDef;
  group: UntypedFormGroup;
  row:Object;
  @ViewChild('inp') inp: ElementRef;
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  maskEditField:MaskEditField;
  entityName:string;
  entityDesc:string;
  tabindex:string;
  padding:boolean;
  toolTipText = null;
  showBuscaDados:boolean = true;
  
  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }
  
  constructor(public dynaServices:DynamicFormsService, public cd:ChangeDetectorRef) {  }
  ngOnChanges(changes: SimpleChanges): void {
    
  }
  
  
  ngOnInit() {  
      
  }

  ngAfterViewInit(){
    
    if ( this.maskEditField != null){
      if ( this.maskEditField.padding !=null){
        let value = this.group.get(this.config.COLUMNNAME).value;
        if ( value != null ){
          let m = this.maskEditField.mask;
          if ( m!=null){
            m = m.replace(/\./g,'');
            let k = value.toString().padStart(m.length,'0');
            if ( this.group.get(this.config.COLUMNNAME)!= null ){
              this.group.get(this.config.COLUMNNAME).patchValue(k);
            }
            this.cd.detectChanges();
          }
        }
      }
    }    
  }


  editing(){
    this.editEvent.next(true)
  }
 
}
